module.exports = __webpack_public_path__ + "static/media/PLANTA.0cfda3cd.jpg";